import AxiosInterceptor from "../utils/AxiosInterceptor";
import { API_BASE } from '../utils/constants';

export const apiAuth = {
    resetPassword: (value) => AxiosInterceptor().post(API_BASE + "/auth/update-password", value),
    getAdminDetails: (value) => AxiosInterceptor().get(API_BASE + "/auth/getAdminDetails", value),
    updateAdminProfile: (value) => AxiosInterceptor().post(API_BASE + "/auth/editProfile", value),
    changePassword: (value) => AxiosInterceptor().post(API_BASE + "/auth/changePassword", value),
    getSetting: (value) => AxiosInterceptor().get(API_BASE + "/setting/get-setting", value),
    updateSetting: (value) => AxiosInterceptor().post(API_BASE + "/setting/add-setting", value),
};

export const userServices = {
    getUser: (values) => AxiosInterceptor().post(`/user/getAllUser`, values),
    getById: (values) => AxiosInterceptor().get(`/user/getOneUser/${values?.id}`),
    add: (values) => AxiosInterceptor().post(`/user/addUser`, values),
    edit: (value) => AxiosInterceptor().post(`/user/updateuser`, value),
    deleteUser: (value) => AxiosInterceptor().post(`/user/deleteUser`, value),
    changeStatus: (value) => AxiosInterceptor().post(`/user/changeStatus`, value),
    modelverify: (value) => AxiosInterceptor().post(`/user/approveDocument`, value),
    getusertransaction: (values) => AxiosInterceptor().post(`/wallet/getusertransaction`, values),
    ApproveRejectAmount: (value) => AxiosInterceptor().post(`/wallet/update-status`, value),
    getByIdTransation: (values) => AxiosInterceptor().get(`/wallet/getOnetransaction/${values?.id}`),

};

export const bitPackageServices = {
    add: (values) => AxiosInterceptor().post(`/bidPackage/bid-package`, values),
    getBids: (values) => AxiosInterceptor().post(`/bidPackage/get-bid-package`, values),
    getById: (values) => AxiosInterceptor().post(`/bidPackage/get-single-bid-package`, values),
    edit: (value) => AxiosInterceptor().post(`/bidPackage/update-bid-package`, value),
    deleteBid: (value) => AxiosInterceptor().post(`/bidPackage/delete-bid-package`, value),
    changeStatus: (value) => AxiosInterceptor().post(`/bidPackage/update-status`, value),
};

export const emailServices = {
    // Email
    getEmail: (values) => AxiosInterceptor().post(`/emailtemp/getAllTemplate`, values),
    addEmail: (value) => AxiosInterceptor().post(`/emailtemp/addtemp`, value),
    getByIdEmail: (values) => AxiosInterceptor().get(`/emailtemp/getonetemp/${values.id}`,),
    editEmail: (value) => AxiosInterceptor().post(`/emailtemp/updatetemp`, value),
    deleteEmail: (value) => AxiosInterceptor().post(`/deleteTemplate`, value),
    changeStatusEmail: (value) => AxiosInterceptor().post("/emailtemp/changetempStatus", value),
};

export const apiCategory = {
    add: (value) => AxiosInterceptor().post(`/category/category`, value),
    edit: (value) => AxiosInterceptor().post(`/category/update-category`, value),
    delete: (value) => AxiosInterceptor().post(`/category/delete-category`, value),
    getAll: (values) => AxiosInterceptor().post(`/category/categories`, values),
    getById: (values) => AxiosInterceptor().post(`/category/single-category`, values),
    changeStatus: (value) => AxiosInterceptor().post("/category/update-status", value),
    getAllSubCategory: (values) => AxiosInterceptor().post(`/subcategory/getAllSubcategories`, values),
    addSubCategory: (value) => AxiosInterceptor().post(`/subcategory/add-subcategory`, value),
    editSubCategory: (value) => AxiosInterceptor().post(`/subcategory/edit-subcategory`, value),
    deleteSubCategory: (value) => AxiosInterceptor().post(`/subcategory/delete-subcategory`, value),
    getByIdSubCategory: (values) => AxiosInterceptor().post(`/subcategory/get-by-id`, values),
    changeStatusSubCategory: (value) => AxiosInterceptor().post("/subcategory/update-status", value),
};

export const apiCms = {
    add: (value) => AxiosInterceptor().post(`/cms/addContent`, value),
    edit: (value) => AxiosInterceptor().post(`/cms/updateContent`, value),
    delete: (value) => AxiosInterceptor().post(`/delete`, value),
    getAll: (values) => AxiosInterceptor().post(`/cms/getAllContent`, values),
    getById: (values) => AxiosInterceptor().get(`/cms/getOneContent/${values.id}`, values),
    changeStatus: (value) => AxiosInterceptor().post("/update-status", value),

    // Faq
    getFaq: (values) => AxiosInterceptor().post(`/faq/getAllFaq`, values),
    addFaq: (value) => AxiosInterceptor().post(`/faq/addFaq`, value),
    getByIdFaq: (values) => AxiosInterceptor().get(`/faq/getFaq/${values.id}`),
    editFaq: (value) => AxiosInterceptor().post(`/faq/updateFaq`, value),
    deleteFaq: (value) => AxiosInterceptor().post(`/faq/deleteFaq`, value),
    changeStatusFaq: (value) => AxiosInterceptor().post("/faq/changeStatus", value),
};

export const ticketManagementServices = {
    getAllTicket: (values) => AxiosInterceptor().post(`/ticketManagement/getAllTicket`, values),
    getById: (values) => AxiosInterceptor().get(`/ticketManagement/getoneticket/${values?.id}`),
    add: (values) => AxiosInterceptor().post(`/ticketManagement/addTicket`, values),
    edit: (value) => AxiosInterceptor().post(`/ticketManagement/updateTicket`, value),
    deleteTicket: (value) => AxiosInterceptor().post(`/ticketManagement/deleteTicket`, value),
    changeStatus: (value) => AxiosInterceptor().post(`/ticketManagement/changeStatus`, value),
    addResult: (value) => AxiosInterceptor().post(`/ticketManagement/uploadResult`, value),
    UpdateResult: (value) => AxiosInterceptor().post(`/ticketManagement/updateResult`, value),
    getOneResult: (value) => AxiosInterceptor().post(`/ticketManagement/getOneResult`, value),
};


export const LicenseServices = {
    getById: (values) => AxiosInterceptor().get(`/license/getlicense`),
    edit: (value) => AxiosInterceptor().post(`/license/upload-license`, value),
};

export const NotificationServices = {
    getNotification: (value) => AxiosInterceptor().get("/notification/getNotifications", value),
    updateStatus: (value) => AxiosInterceptor().post("/notification/enable-notification", value),
    getAll: (value) => AxiosInterceptor().post("/notification/getAllTemplates", value),
    getById: (value) => AxiosInterceptor().get(`/notification/getTemplate/${value.id}`,),
    update: (value) => AxiosInterceptor().put("/notification/update-notification", value),
};


export const PaymentServices = {
    getAll: (value) => AxiosInterceptor().post("/paymentManagement/paymentDetails", value),
};